function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#F5F5F0;}\r\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill-opacity:0.16;}\r\n\t.st4{opacity:0.16;fill:none;stroke:#000000;stroke-width:13.4;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st5{opacity:0.16;fill:none;stroke:#000000;stroke-width:9.2;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st6{opacity:0.16;fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st7{opacity:0.16;fill:none;stroke:#000000;stroke-width:2.2;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st8{opacity:0.16;fill:none;stroke:#000000;stroke-width:2.6;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st9{opacity:0.16;fill:none;stroke:#000000;stroke-width:5.1;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st10{opacity:0.16;fill:none;stroke:#000000;stroke-width:21.6;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st11{opacity:0.16;fill:none;stroke:#000000;stroke-width:17.5;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st12{opacity:0.16;fill:none;stroke:#000000;stroke-width:34;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st13{opacity:0.16;fill:none;stroke:#000000;stroke-width:15.4;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st14{fill:#FFFFFF;stroke:#3287BA;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st15{fill:#3287BA;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "-30.7,-21.3 -24.9,424.5 700,424.5 687,-21.3 "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M-221.8,202.3c50.2-13,103.5-7,149.6,16.7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M-221.8,202.3C-161.9,69.4-42.2-26.9,100.4-56.9"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M-221.8,202.3c30.2-45.3,73-80.8,123-102.1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M-18.2,258.7c-8.1-29.6-8.8-60.7-2-90.7"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M148.7-64.3c37.8,5.5,73.7,20,104.8,42.3"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M28.9,78.4C37.5,29.8,65-13.4,105.4-41.8"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "-50.6,231.8 -67,208.9 -77.4,229 "
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "80.6,234.3 60.4,208.2 48.7,232.3 "
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "107,-58.2 99.8,-59.9 101.1,-53.9 "
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "-61.7,87.4 -105.6,84.1 -91.9,116.3 "
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "-17.3,156.8 -25.3,166.9 -15.3,169.2 "
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "208.3,96.5 185.6,93.6 191.3,111.1 "
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "45.3,167.9 45.3,180.6 54.5,176.3 "
});

var _ref17 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "221.8,142.5 190,154.4 209.5,172.7 "
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "620.3,147.2 619,141.9 615.5,144.7 "
});

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "258.4,-18.5 255.1,-24.2 252,-19.9 "
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "607.1,281.2 612.7,277.8 608.4,274.8 "
});

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "606.7,96 603.5,108.5 613.6,106.4 "
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "127.2,206.6 128.6,194 118.9,197.4 "
});

var _ref23 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "111,-45.6 103.6,-44.3 107.1,-39.3 "
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "214.7,42.1 164.8,18.5 166.5,61.7 "
});

var _ref25 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "192.2,314.6 226.2,356.2 243.5,316.6 "
});

var _ref26 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "608.6,202.7 596.4,205.7 603,213.6 "
});

var _ref27 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "374.9,206.7 381.9,250.3 410.2,229.8 "
});

var _ref28 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "200.5,250.4 243.8,243.9 223.3,215.6 "
});

var _ref29 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "614.5,152.2 608.9,141 602.6,149.1 "
});

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "500.2,246.9 487.6,160.6 433.9,202.3 "
});

var _ref31 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "542.3,10.3 506.9,-4.8 509,26 "
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M-221.8,202.3c90.9-30.5,190.1-24.1,276.3,17.9"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M-18.2,258.7c49.4-73.9,122.2-129,206.7-156.4"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M136.2,274.8c-37.6-22.9-67.6-56.4-86.3-96.3"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M136.2,274.8c12.2-41.5,34-79.6,63.6-111.2"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M148.7-64.3c180.7-11.6,355.7,66,468.5,207.6"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M644.9,181.3c-3.3,34-15.1,66.7-34.4,95"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M644.9,181.3c-18.3-21-30.9-46.5-36.4-73.9"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M28.9,78.4c44.2,26.9,77.8,68.4,94.9,117.3"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M28.9,78.4c42-23.2,88.8-36.3,136.8-38.2"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M527.2,346.5c-95.2,33.9-199.7,30.3-292.3-10.1"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M527.2,346.5c5.1-53.4,31.2-102.6,72.5-136.8"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M527.2,346.5c-52.3-23.3-97.6-60-131.1-106.4"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M336.4,83.9c-17.2,58.6-53.4,109.9-102.8,145.8"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M336.4,83.9C430.8,63,529.6,85.4,605.7,145"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M336.4,83.9c48.9,21.8,91.6,55.2,124.4,97.5"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M336.4,83.9C383.7,40.9,444.2,15,508,10.6"
});

var _ref48 = /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: -18.2,
  cy: 258.7,
  r: 42.1
});

var _ref49 = /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: 136.2,
  cy: 274.8,
  r: 68.8
});

var _ref50 = /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: 148.7,
  cy: -64.3,
  r: 42.1
});

var _ref51 = /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: 644.9,
  cy: 181.3,
  r: 42.1
});

var _ref52 = /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: 30.6,
  cy: 82,
  r: 91
});

var _ref53 = /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: 527.2,
  cy: 346.5,
  r: 103.2
});

var _ref54 = /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: 336.4,
  cy: 83.9,
  r: 128.7
});

var _ref55 = /*#__PURE__*/React.createElement("circle", {
  className: "st15",
  cx: -221.8,
  cy: 202.3,
  r: 108.8
});

var _ref56 = /*#__PURE__*/React.createElement("circle", {
  className: "st15",
  cx: 614.1,
  cy: 23.4,
  r: 73
});

var SvgNetwork = function SvgNetwork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 647 400",
    style: {
      enableBackground: "new 0 0 647 400"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNetwork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/network.6ef3f646.svg";
export { ForwardRef as ReactComponent };